import gsap from "gsap";
import Panzoom from "@panzoom/panzoom";


//-----------------------------------------------
// Neighborhood Map
//-----------------------------------------------

function init_map_sections_accordion(mapBlock) {
  const sectionItems = Array.from(mapBlock.querySelectorAll(".section-item"));
  if (!sectionItems.length) return;

  const toggleSection = (item, expand) => {
    const content = item.querySelector(".section-item--contents");
    if (!content) return;

    gsap.killTweensOf(content);

    if (expand) {
      item.classList.add("active");
      gsap.fromTo(
        content,
        { height: 0 },
        { height: "auto", duration: 0.5, ease: "power2.out" },
      );
      return;
    }

    item.classList.remove("active");
    gsap.to(content, { height: 0, duration: 0.5, ease: "power2.inOut" });
  };

  sectionItems.forEach((item, index) => {
    const title = item.querySelector(".section-item--title");
    const content = item.querySelector(".section-item--contents");
    if (!title || !content) return;

    if (index === 0) {
      item.classList.add("active");
      gsap.set(content, { height: "auto", overflow: "hidden" });
    } else {
      item.classList.remove("active");
      gsap.set(content, { height: 0, overflow: "hidden" });
    }

    title.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      if (isActive) {
        toggleSection(item, false);
        return;
      }

      sectionItems.forEach((otherItem) => {
        if (otherItem !== item) {
          toggleSection(otherItem, false);
        }
      });

      toggleSection(item, true);
    });
  });
}

function neighborhood_map() {
  const mapContainers = document.querySelectorAll(
    ".neighborhood-map .map-container",
  );
  if (!mapContainers.length) return;

  mapContainers.forEach((container) => {
    const mapBlock = container.closest(".neighborhood-map");

    if (mapBlock && !mapBlock.dataset.sectionsAccordionReady) {
      init_map_sections_accordion(mapBlock);
      mapBlock.dataset.sectionsAccordionReady = "true";
    }

    const target = container.querySelector("img, svg");
    if (!target) return;

    let panzoom;
    let resizeTimer;

    const initPanzoom = () => {
      const containerRect = container.getBoundingClientRect();
      const naturalWidth = target.naturalWidth || target.clientWidth;
      const naturalHeight = target.naturalHeight || target.clientHeight;

      if (
        !containerRect.width ||
        !containerRect.height ||
        !naturalWidth ||
        !naturalHeight
      ) {
        return;
      }

      const fitScale =
        Math.max(
          containerRect.width / naturalWidth,
          containerRect.height / naturalHeight,
        ) + 0.002;

      if (panzoom) {
        panzoom.setOptions({
          startScale: fitScale,
          minScale: fitScale,
          maxScale: fitScale * 5,
        });
        panzoom.reset({ animate: false, force: true });
        target.style.cursor = "grab";
        return;
      }

      panzoom = Panzoom(target, {
        startScale: fitScale,
        minScale: fitScale,
        maxScale: fitScale * 5,
        contain: "outside",
        cursor: "grab",
      });

      target.style.cursor = "grab";
    };

    const resetToFit = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        window.requestAnimationFrame(() => {
          initPanzoom();
          window.setTimeout(initPanzoom, 220);
        });
      }, 120);
    };

    const wheelHandler = (event) => {
      if (!panzoom) return;
      event.preventDefault();
      panzoom.zoomWithWheel(event);
    };

    container.addEventListener("wheel", wheelHandler, { passive: false });

    target.addEventListener("panzoomstart", () => {
      target.style.cursor = "grabbing";
    });

    target.addEventListener("panzoomend", () => {
      target.style.cursor = "grab";
    });

    const scope =
      container.closest(".map-cell-liner") || container.parentElement;

    const zoomInBtn = scope?.querySelector(
      "[data-map-zoom-in], .map-zoom-icon.plus",
    );
    const zoomOutBtn = scope?.querySelector(
      "[data-map-zoom-out], .map-zoom-icon.minus",
    );
    const resetBtn = scope?.querySelector("[data-map-reset]");

    const bindMapControl = (button, handler) => {
      button?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        handler();
      });
    };

    bindMapControl(zoomInBtn, () => panzoom?.zoomIn());
    bindMapControl(zoomOutBtn, () => panzoom?.zoomOut());
    bindMapControl(resetBtn, () => panzoom?.reset());

    window.addEventListener("resize", resetToFit);
    window.addEventListener("orientationchange", resetToFit);

    const breakpointQueries = ["(min-width: 64em)", "(min-width: 75em)"];
    const mediaQueryLists = breakpointQueries.map((query) =>
      window.matchMedia(query),
    );
    mediaQueryLists.forEach((mediaQueryList) => {
      mediaQueryList.addEventListener("change", resetToFit);
    });

    if (target.tagName.toLowerCase() === "img" && !target.complete) {
      target.addEventListener("load", initPanzoom, { once: true });
      return;
    }

    initPanzoom();
  });
}

neighborhood_map();

